import { render, staticRenderFns } from "./TextWithImage.vue?vue&type=template&id=258e453a"
import script from "./TextWithImage.vue?vue&type=script&lang=js"
export * from "./TextWithImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports